import React from "react";
import { Button, Modal, Switch, Table } from "antd";
import { useApi } from "../../../../../hooks/http2";
import { displayTotal } from "../../../../../utils/helper";
import dayjs from "dayjs";
import { FaCog, FaCogs } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { axios } from "../../../../../utils/useAxios";
import { STATUS } from "../constants/status.constant";
import { useHardPromotionMutate } from "../contexts/hard-promotion.context";
import {
  PROMOTION_TYPE_TEXT,
  PROMOTION_CONDITION_TYPE_TEXT,
} from "../constants/type.constant";

const TableHardPromotion = () => {
  const history = useHistory();
  const {
    state: { filter },
    dispatch,
  } = useHardPromotionMutate();
  const list = useApi(
    {
      url: `/marketing/hard-promotion`,
      token: true,
      params: {
        ...filter,
        offset: (filter.page - 1) * (filter.limit || 0),
      },
    },
    [filter],
  );

  const handleChangeStatus = async (id, checked) => {
    Modal.confirm({
      type: "warning",
      title: "ยืนยันการทำรายการ",
      content: "คุณต้องการปรับการแสดงผลหรือไม่",
      okText: "ยืนยัน",
      cancelText: "ยกเลิก",
      onOk: async () => {
        return new Promise(async (resolve, reject) => {
          try {
            const status = checked ? STATUS.ACTIVE : STATUS.IN_ACTIVE;
            await axios.post(`/marketing/hard-promotion/${id}/${status}`);
            resolve();
          } catch (error) {
            reject(error);
          }
        })
          .then(() => {
            Modal.success({
              title: "สำเร็จ",
              content: "ปรับการแสดงผลเรียบร้อย",
              okText: "ปิด",
              onOk: () => list.reload(),
            });
          })
          .catch((reason) =>
            Modal.error({ title: "ผิดพลาด", content: reason, okText: "ปิด" }),
          );
      },
    });
  };

  return (
    <Table
      size="small"
      bordered
      loading={list.loading}
      dataSource={list.fetch?.list || []}
      pagination={{
        size: "default",
        total: list.fetch?.total,
        showLessItems: true,
        showTotal: displayTotal,
        pageSize: filter.limit,
        current: filter.page,
        onChange: (page) => dispatch({ type: "SET_FILTER", payload: { page } }),
      }}
      rowKey={"id"}
    >
      <Table.Column key="code" title="รหัส" dataIndex="code" align="center" />
      <Table.Column key="name" title="ชื่อโปรโมชัน" dataIndex="name" />
      <Table.Column
        key="type"
        title="เงื่อนไข"
        dataIndex="condition_type"
        align="center"
        render={(text) =>
          PROMOTION_CONDITION_TYPE_TEXT[text?.toUpperCase()] || text
        }
      />
      <Table.Column
        key="type"
        title="ประเภท"
        dataIndex="type"
        align="center"
        render={(text) => PROMOTION_TYPE_TEXT[text?.toUpperCase()] || text}
      />
      <Table.Column
        key="promotion_date"
        title="โปรโมชันมีผลวันที่"
        dataIndex="start_date"
        align="center"
        render={(start_date, { end_date }) =>
          `${dayjs(start_date).format("DD/MM/YYYY")} - ${dayjs(end_date).format(
            "DD/MM/YYYY",
          )}`
        }
      />
      <Table.Column
        key="status"
        title="แสดงผล"
        dataIndex="status"
        align="center"
        render={(status, { id }) => {
          const is_active = status === STATUS.ACTIVE;
          return (
            <Switch
              checked={is_active}
              onChange={(checked) => handleChangeStatus(id, checked)}
            />
          );
        }}
      />
      <Table.Column
        key="action"
        title={<FaCogs />}
        dataIndex="id"
        align="center"
        render={(id) => (
          <Button
            size="small"
            type="primary"
            ghost
            onClick={() => history.push(`/marketing/hard-promotion/${id}`)}
          >
            <FaCog />
          </Button>
        )}
      />
    </Table>
  );
};

export default TableHardPromotion;
